import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _methods;

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { GetImsVendorLoadData } from '@/api/MaintainDeliveryNote2';
import util from '@/libs/util';
import changeVendorDialog from './changeVendorDialog';
import { GetReportID as _GetReportID } from '@/api/SysReportTpl';
import { GetDnbarcodePartBoxDtlList, LoadData, ExportBoxCodeData, GetLastById, GetNextById } from '@/api/DnbarcodeHandmade';
import ExportListMixin from '@/views/mixin/ExportList';
export default {
  mixins: [ExportListMixin],
  components: {
    changeVendorDialog: changeVendorDialog
  },
  mounted: function mounted() {
    this.formData.CREATE_DATE = this.getNowDate(new Date());
    this.formData.CREATORID = JSON.parse(util.cookies.get('userInfo')).USER_NAME;
    this.GetReportID();
  },
  data: function data() {
    return {
      formData: {
        DELIVERY_NO: null,
        // 送货单号
        CREATORID: null,
        // 制单人
        DESCRIPTION: null,
        // 备注
        CREATE_DATE: null,
        // 创建日期
        VENDOR_NAME: util.getUserInfo().VENDOR_NAME || null,
        // 供应商名称
        VENDOR_CODE: util.getUserInfo().VENDOR_CODE || null
      },
      // mode:'show',
      vendorOptions: [],
      selectLoading: false,
      Rules: {
        VENDOR_CODE: [{
          required: true,
          message: '供应商不能为空',
          trigger: ['blur', 'change']
        }]
      },
      isShowChangeVendorDialog: false,
      // 显示选择供应商dialog
      isDisabled: false,
      VENDOR_NAME: null,
      CREATE_DATE: null,
      DESCRIPTION: null,
      userInfo: util.getUserInfo(),
      ID: null
    };
  },
  methods: (_methods = {
    getData: function getData() {
      return this.formData;
    },
    // 设置ID
    setID: function setID(MST_ID) {
      this.ID = MST_ID;
      this.formData.ID = MST_ID;
    },
    // 设置数据
    setData: function setData(data) {
      this.formData.DELIVERY_NO = data.DELIVERY_NO;
      this.formData.CREATORID = data.CREATORID;
      this.formData.DESCRIPTION = data.DESCRIPTION;
      this.formData.DELIVERY_DATE = util.formatTime.transCommDate(data.DELIVERY_DATE);
      this.formData.VENDOR = data.VENDOR_NAME;
      this.formData.ARRIVAL_DATE = util.formatTime.transCommDate(data.ARRIVAL_DATE);
      this.formData.STATUS_Caption = data.STATUS_Caption;
      this.formData.VENDOR_CODE = data.VENDOR_CODE;
      this.formData.ID = data.ID;
      this.ID = data.ID;
    },
    // 上一张单据更新数据
    getBackUpdata: function getBackUpdata() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.formData);
                params = {
                  mst_id: _this.formData.ID ? _this.formData.ID : _this.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context.next = 4;
                return GetNextById(params);

              case 4:
                res = _context.sent;
                console.log('上一张res', res);

                if (res.code === 0) {
                  if (res.data) {
                    _this.setData(res.data);

                    _this.$emit('cbNextOrder', res.data, res.data.STATUS);
                  } else {
                    _this.$message.warning('当前单据已为最前单据');
                  }
                } else {
                  _this.$message.warning('切换上一张单据失败');
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 下一张单据更新数据
    nextOrderUpdata: function nextOrderUpdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(_this2.formData);
                params = {
                  mst_id: _this2.formData.ID ? _this2.formData.ID : _this2.ID,
                  organize_id: util.cookies.get('ORG_ID')
                };
                _context2.next = 4;
                return GetLastById(params);

              case 4:
                res = _context2.sent;
                console.log(res);

                if (res.code === 0) {
                  if (res.data) {
                    _this2.setData(res.data);

                    _this2.$emit('cbNextOrder', res.data, res.data.STATUS);
                  } else {
                    _this2.$message.warning('当前单据已为最后单据');
                  }
                } else {
                  _this2.$message.warning('切换下一张单据失败');
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 导出条码明细数据
    ExportPartBarcodeData: function ExportPartBarcodeData() {
      // console.log('this.ID',this.ID);
      var params = {
        ORGANIZE_ID: util.cookies.get('ORG_ID'),
        MST_ID: this.ID,
        EXPORT_FILE_NAME: '手工外箱条码明细'
      };
      this.$message.success('已添加到 导出列表 中');
      this.setUnreadExportMessionNum();
      ExportBoxCodeData(params);
    },
    // 更新内容
    updataInfo: function updataInfo() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$refs.formData.clearValidate();

                params = {
                  Page: 1,
                  Limit: 10,
                  LIST_ROUTE: '/DeliveryNote/DnbarcodeHandmade',
                  Data: {
                    ID: _this3.ID,
                    ORGANIZE_ID: util.cookies.get('ORG_ID')
                  }
                };
                _context3.next = 4;
                return LoadData(params);

              case 4:
                res = _context3.sent;
                console.log('更新表单内容', res);

                if (res.code === 0) {
                  _this3.formData.DELIVERY_NO = res.data.Items[0].DELIVERY_NO;
                  _this3.formData.CREATORID = res.data.Items[0].CREATORID;
                  _this3.formData.DESCRIPTION = res.data.Items[0].DESCRIPTION;
                  _this3.formData.CREATE_DATE = res.data.Items[0].CREATETIME;
                  _this3.formData.VENDOR_NAME = res.data.Items[0].VENDOR_NAME;
                  _this3.formData.VENDOR_CODE = res.data.Items[0].VENDOR_CODE;
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 获取当前时间
    getNowDate: function getNowDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    // 获取打印模板id
    GetReportID: function GetReportID() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  billtype: 'BoxQrCode'
                };
                _context4.next = 3;
                return _GetReportID(params);

              case 3:
                res = _context4.sent;
                console.log('模板id', res);

                if (res.code === 0) {
                  _this4.templateID = res.data;
                } else {
                  _this4.$message.warning('获取打印模板失败');
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 单行打印
    PrintRowOuterBoxLabel: function PrintRowOuterBoxLabel(row) {
      console.log('row', row);
      console.log('this.formData', this.formData);

      if (!this.templateID) {
        this.$message({
          showClose: true,
          message: this.$t('找不到条码打印模板！'),
          type: 'warning'
        });
        return;
      }

      var ID = row.ID ? row.ID : this.formData.ID;
      var token = util.cookies.get('token');
      var dataurl = process.env.VUE_APP_API + "/DnBarcode/GetBoxCodeDetailPrintData?mst_id=".concat(ID);
      var dxurl = this.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport';
      var url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(this.templateID, "&Token=").concat(token); // console.log('打印url',url);

      util.open(url);
    },
    // 组合打印
    PrintParBarcodeGroup: function PrintParBarcodeGroup() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var MST_ID, params, res, token, dataurl, dxurl, url;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.templateID) {
                  _context5.next = 3;
                  break;
                }

                _this5.$message({
                  showClose: true,
                  message: _this5.$t('找不到条码打印模板！'),
                  type: 'warning'
                });

                return _context5.abrupt("return");

              case 3:
                MST_ID = _this5.formData.ID ? _this5.formData.ID : _this5.ID;
                params = {
                  MST_ID: MST_ID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _context5.next = 7;
                return GetDnbarcodePartBoxDtlList(params);

              case 7:
                res = _context5.sent;
                console.log('外箱手工条码列表', res);

                if (res.code === 0) {
                  if (res.data.length === 0) {
                    _this5.$message.warning('打印失败，条码列表为空');
                  } else {
                    token = util.cookies.get('token');
                    dataurl = process.env.VUE_APP_API + "/DnBarcode/GetBoxCodeDetailPrintData?mst_id=".concat(MST_ID);
                    dxurl = _this5.$store.getters.getVUE_APP_PRINT_TPL + 'Home/PreviewReport';
                    url = "".concat(dxurl, "?DATA_URL=").concat(dataurl, "&REPORT_ID=").concat(_this5.templateID, "&Token=").concat(token);
                    util.open(url);
                  }
                } else {
                  _this5.$message.warning('获取条码列表失败');
                }

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 设置表头
    setFormData: function setFormData(data) {
      console.log('设置表头', data);
      this.ID = data.ID;
      this.formData.VENDOR_CODE = data.VENDOR_CODE;
      this.formData.VENDOR_NAME = data.VENDOR_NAME;
      this.formData.DESCRIPTION = data.DESCRIPTION;
      this.formData.ID = data.ID;
      this.formData.DELIVERY_NO = data.DELIVERY_NO; // this.formData.VENDOR_CODE = data.VENDOR_CODE
      // this.VENDOR_NAME = data.VENDOR_NAME
      // this.CREATE_DATE = data.CREATETIME
      // this.DESCRIPTION = data.DESCRIPTION
    }
  }, _defineProperty(_methods, "getData", function getData() {
    return this.formData;
  }), _defineProperty(_methods, "valiVendorName", function valiVendorName() {
    var _this6 = this;

    var VENDOR_CODE = this.formData.VENDOR_CODE;
    return new Promise(function (resove) {
      _this6.$refs.formData.validate(function (bool) {
        if (bool === true) {
          resove({
            vali: true,
            VENDOR_CODE: VENDOR_CODE
          });
        } else {
          resove({
            vali: false,
            VENDOR_CODE: VENDOR_CODE
          });
        }
      });
    });
  }), _defineProperty(_methods, "cbDialogSubmit", function cbDialogSubmit(_ref) {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var vendorObj, dialogData;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              vendorObj = _ref.vendorObj, dialogData = _ref.dialogData;
              // console.log('vendorObj',vendorObj);
              // console.log('dialogData',dialogData);
              _this7.vendorOptions = dialogData.map(function (item) {
                return {
                  key: item.Id,
                  value: item.Code,
                  label: item.Code + ' - ' + item.Name,
                  name: item.Name
                };
              }); // this.formData.VENDOR_CODE = vendorObj.Code
              // this.getVendorList(vendorObj.Name)

              _this7.formData.VENDOR_CODE = vendorObj.Code;
              _this7.formData.VENDOR_NAME = vendorObj.Name;

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }), _defineProperty(_methods, "closeChangeVendorDialog", function closeChangeVendorDialog(value) {
    this.isShowChangeVendorDialog = value;
  }), _defineProperty(_methods, "handleChangeVendorBtn", function handleChangeVendorBtn() {
    var _this8 = this;

    this.isShowChangeVendorDialog = true;
    this.$nextTick(function () {
      _this8.$refs.changeVendorDialog.GetVendorList();
    });
  }), _defineProperty(_methods, "handleChange", function handleChange() {
    var _this9 = this;

    // console.log('选择',this.formData.VENDOR_CODE);
    this.vendorOptions.forEach(function (v) {
      if (v.value === _this9.formData.VENDOR_CODE) {
        _this9.formData.VENDOR_NAME = v.name;
      }
    });
  }), _defineProperty(_methods, "handleInputVendorSelect", function handleInputVendorSelect(value) {
    // console.log(value);
    if (value !== '') {
      this.selectLoading = true;
      this.getVendorList(value);
    } else {}
  }), _defineProperty(_methods, "handleVendorInput", function handleVendorInput() {}), _defineProperty(_methods, "getVendorList", function getVendorList() {
    var _arguments = arguments,
        _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var Key, params, res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              Key = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
              params = {
                ORGANIZE_ID: util.cookies.get('ORG_ID'),
                Page: 1,
                Limit: 999,
                Key: Key
              };
              _context7.next = 4;
              return GetImsVendorLoadData(params);

            case 4:
              res = _context7.sent;
              // console.log('供应商列表 res',res);
              _this10.selectLoading = false;

              if (res.code === 0) {
                _this10.vendorOptions = res.data.Items.map(function (item) {
                  return {
                    key: item.Id,
                    value: item.Code,
                    label: item.Code + ' - ' + item.Name,
                    name: item.Name
                  };
                });
              }

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }), _methods),
  watch: {
    $DnbarcodeHandmadeOutBoxState: {
      handler: function handler(nawValue) {
        console.log('单据操作状态 $DnbarcodeHandmadeOutBoxState==>', nawValue);

        if (nawValue === 'orderShow') {
          this.isDisabled = true;
        } else if (nawValue === 'editOrder') {
          this.isDisabled = false;
        } else {}
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DnbarcodeHandmadeOutBoxState']))
};